module.exports = __webpack_public_path__ + "static/media/IMG-5.67bfe85f.jpg";